import { AdminAppStats } from "api";
import { Credentials } from "auth";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";
import { AdminEndAction, ErrorPayload } from "./ErrorAction";

export type AdminFetchAppStats = "ADMIN_FETCH_APP_STATS";
export const ADMIN_FETCH_APP_STATS: AdminFetchAppStats = "ADMIN_FETCH_APP_STATS";

export type AdminFetchAppStatsEnd = "ADMIN_FETCH_APP_STATS_END";
export const ADMIN_FETCH_APP_STATS_END: AdminFetchAppStatsEnd = "ADMIN_FETCH_APP_STATS_END";

export interface AdminFetchAppStatsAction extends Action {
    type: AdminFetchAppStats;
    payload: {
        credentials: Credentials;
    };
}

export function fetchAdminAppStats(): ThunkAction<any, State, any, AdminFetchAppStatsAction> {
    return (dispatch: Dispatch<AdminFetchAppStatsAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(fetchAdminAppStatsWithCredentials(credentials));
    };
}

function fetchAdminAppStatsWithCredentials(credentials: Credentials): AdminFetchAppStatsAction {
    return {
        payload: {
            credentials
        },
        type: ADMIN_FETCH_APP_STATS
    };
}

export interface AdminFetchAppStatsEndPayload extends ErrorPayload {
    stats?: AdminAppStats;
}

export interface AdminFetchAppStatsEndAction extends AdminEndAction<AdminFetchAppStatsEndPayload> {
    type: AdminFetchAppStatsEnd;
}

export function fetchAdminAppStatsEnd(error?: Error, stats?: AdminAppStats): AdminFetchAppStatsEndAction {
    return {
        payload: {
            error,
            stats
        },
        type: ADMIN_FETCH_APP_STATS_END
    };
}
